export default {
    items: [
        {
            type: 'inline',
            items: [
                {
                    type: 'text-field',
                    name: 'full-name',
                    width: 0,
                    props: {
                        hidden: true,
                        formula: {
                            name: 'join',
                            arguments: {
                                targets: [
                                    'first-name',
                                    'last-name'
                                ]
                            }
                        }
                    }
                },
                {
                    type: 'text-field',
                    name: 'first-name',
                    width: 6,
                    props: {
                        label: 'First Name'
                    }
                },
                {
                    type: 'text-field',
                    name: 'last-name',
                    width: 6,
                    props: {
                        label: 'Last Name'
                    }
                }
            ]
        },
        {
            type: 'inline',
            items: [
                {
                    type: 'text-field',
                    name: 'address',
                    width: 12,
                    props: {
                        label: 'Address',
                        tooltip: 'Can be a business address'
                    },
                }
            ]
        },
        {
            type: 'inline',
            items: [
                {
                    type: 'text-field',
                    name: 'city',
                    width: 6,
                    props: {
                        label: 'City'
                    }
                },
                {
                    type: 'selectlist',
                    name: 'state',
                    width: 2,
                    props: {
                        label: 'State',
                        items: []
                    }
                },
                {
                    type: 'text-field',
                    name: 'zip',
                    width: 4,
                    props: {
                        label: 'Zip'
                    }
                }
            ]
        }
    ]
}


// WEBPACK FOOTER //
// ./src/components/entity-existing/data_table_forms/director-information.js